import { useEffect } from "react";
import dayjs from "dayjs";
import { Button, Form, Flex, Input, InputNumber } from "antd";

import StyledContainer from "./style";

import {
  selectValue,
  setPhoneMask,
} from "../../../../../../../../../utils/helper/general";

const TabAbout = ({ clientData, disableEdit, onClickEditInfo }) => {
  const [formPersonalInfo] = Form.useForm();
  const [formSpouseInfo] = Form.useForm();
  const [formDependents] = Form.useForm();

  useEffect(() => {
    if (!clientData) return;

    formPersonalInfo.setFieldsValue({
      firstName: clientData.firstName,
      lastName: clientData.lastName,
      email: clientData.email,
      phoneNumber:
        clientData.valueMap?.leadInitial?.phoneNumber ??
        clientData.valueMap?.guideInitialData?.phoneNumber,
      phoneAlt:
        clientData.valueMap?.leadInitial?.phoneAlt ??
        clientData.valueMap?.guideInitialData?.phoneAlt,
      birthYear:
        clientData.birthYear ?? clientData.valueMap?.guideInitialData?.yearBorn,
      retirementAge:
        clientData.valueMap?.leadInitial?.retirementAge ??
        clientData.valueMap?.guideInitialData?.retirementAge,
    });

    formSpouseInfo.setFieldsValue(clientData.valueMap?.guideInitialData);

    formDependents.setFieldsValue({
      dependents: clientData.valueMap?.guideInitialData?.dependents,
    });
  }, [clientData]);

  return (
    <StyledContainer vertical>
      <article>
        <div className="container-left">
          <h5>Personal Info</h5>
          <Button
            disabled={disableEdit}
            onClick={() => onClickEditInfo("personal")}
            shape="round"
            size="small"
          >
            Edit
          </Button>
        </div>

        <div className="container-right">
          <Form
            disabled
            form={formPersonalInfo}
            id="formPersonalInfo"
            layout="vertical"
            size="small"
          >
            <Flex gap={16}>
              <Form.Item label="First Name" name="firstName">
                <Input />
              </Form.Item>
              <Form.Item label="Last Name" name="lastName">
                <Input />
              </Form.Item>
            </Flex>
            <Form.Item label="Email" name="email">
              <Input />
            </Form.Item>
            <Flex gap={16}>
              <Form.Item label="Phone" name="phoneNumber">
                <InputNumber formatter={setPhoneMask} />
              </Form.Item>
              <Form.Item label="Phone alt" name="phoneAlt">
                <InputNumber formatter={setPhoneMask} />
              </Form.Item>
            </Flex>
            <Flex gap={16}>
              <Form.Item label="Birth Year" name="birthYear">
                <InputNumber />
              </Form.Item>
              <Form.Item label="Retirement Age" name="retirementAge">
                <InputNumber />
              </Form.Item>
            </Flex>
          </Form>
        </div>
      </article>

      <article>
        <div className="container-left">
          <h5>Spouse Info</h5>

          <Button
            disabled={disableEdit}
            onClick={() => onClickEditInfo("spouse")}
            shape="round"
            size="small"
          >
            Edit
          </Button>
        </div>

        <div className="container-right">
          <Form
            disabled
            form={formSpouseInfo}
            id="formSpouseInfo"
            layout="vertical"
            size="small"
          >
            <Flex gap={16}>
              <Form.Item label="First Name" name="spouseFirstName">
                <Input />
              </Form.Item>
              <Form.Item label="Last Name" name="spouseLastName">
                <Input />
              </Form.Item>
            </Flex>
            <Form.Item label="Email" name="spouseEmail">
              <Input />
            </Form.Item>
            <Flex gap={16}>
              <Form.Item label="Phone" name="spousePhoneNumber">
                <InputNumber formatter={setPhoneMask} />
              </Form.Item>
              <Form.Item label="Phone alt" name="spousePhoneAlt">
                <InputNumber formatter={setPhoneMask} />
              </Form.Item>
            </Flex>
            <Flex gap={16}>
              <Form.Item label="Birth Year" name="spouseBirthYear">
                <InputNumber />
              </Form.Item>
              <Form.Item label="Retirement Age" name="spouseRetirementAge">
                <InputNumber />
              </Form.Item>
            </Flex>
          </Form>
        </div>
      </article>

      <article>
        <div className="container-left">
          <h5>Dependents</h5>
          <Button
            disabled={disableEdit}
            onClick={() => onClickEditInfo("dependents")}
            shape="round"
            size="small"
          >
            Edit
          </Button>
        </div>

        <div className="container-right">
          {clientData?.valueMap?.guideInitialData?.dependents?.length ? (
            <Form
              disabled
              form={formDependents}
              id="formDependents"
              layout="vertical"
            >
              <Form.List name="dependents" initialValue={[{}]}>
                {fields => (
                  <Flex gap={16} vertical>
                    {fields.map(field => (
                      <Flex
                        align="start"
                        className="item-dependent"
                        gap={16}
                        justify="space-between"
                        key={field.key}
                      >
                        <Form.Item
                          label="First Name"
                          name={[field.name, "firstName"]}
                        >
                          <Input variant="underlined" />
                        </Form.Item>
                        <Form.Item
                          label="Last Name"
                          name={[field.name, "lastName"]}
                        >
                          <Input variant="underlined" />
                        </Form.Item>
                        <Form.Item
                          label="Birth Year"
                          name={[field.name, "birthYear"]}
                          rules={[
                            {
                              type: "number",
                              min: 1940,
                              max: dayjs().format("YYYY") - 5,
                            },
                          ]}
                        >
                          <InputNumber
                            onClick={selectValue}
                            placeholder="YYYY"
                            variant="underlined"
                          />
                        </Form.Item>
                      </Flex>
                    ))}
                  </Flex>
                )}
              </Form.List>
            </Form>
          ) : (
            <Flex
              align="center"
              className="container-no-dependents"
              justify="center"
            >
              No Dependents
            </Flex>
          )}
        </div>
      </article>
    </StyledContainer>
  );
};

export default TabAbout;
